"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetReport = exports.bulkReportUnrestrict = exports.bulkReportSuccess = exports.bulkReportSubmit = exports.bulkReportSoftDeleteRestore = exports.bulkReportSoftDelete = exports.bulkReportRestrict = exports.bulkReportPlay = exports.bulkReportPause = exports.bulkReportGoLive = exports.bulkReportError = exports.bulkReportDelete = exports.bulkReportApprove = exports.bulkReportAlertOn = exports.bulkReportAlertOff = exports.bulkReportAddMultiple = void 0;
var _reportBulk = require("./reportBulk.constant");
// @flow

// common success
var bulkReportSuccess = function bulkReportSuccess(actionType, data) {
  return {
    type: _reportBulk.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.bulkReportSuccess = bulkReportSuccess;
var bulkReportError = function bulkReportError(actionType, error) {
  return {
    type: _reportBulk.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * bulk site submit
 * @param payload
 * @returns api response
 * @description this function used to bulk site submit.
 */
exports.bulkReportError = bulkReportError;
var bulkReportSubmit = function bulkReportSubmit(payload) {
  return {
    type: _reportBulk.actionTypes.BULK_SUBMIT,
    payload: payload
  };
};

/**
 * bulk delete sites
 * @param payload
 * @returns api response
 * @description this function used to bulk bulk delete multiple sites.
 */
exports.bulkReportSubmit = bulkReportSubmit;
var bulkReportDelete = function bulkReportDelete(payload) {
  return {
    type: _reportBulk.actionTypes.BULK_DELETE,
    payload: payload
  };
};

/**
 * go live
 * @param payload
 * @returns api response
 * @description this function used to go live.
 */
exports.bulkReportDelete = bulkReportDelete;
var bulkReportGoLive = function bulkReportGoLive(payload) {
  return {
    type: _reportBulk.actionTypes.BULK_GO_LIVE,
    payload: payload
  };
};

/**
 * play
 * @param payload
 * @returns api response
 * @description this function used to play states.
 */
exports.bulkReportGoLive = bulkReportGoLive;
var bulkReportPlay = function bulkReportPlay(payload) {
  return {
    type: _reportBulk.actionTypes.BULK_PLAY,
    payload: payload
  };
};

/**
 * pause
 * @param payload
 * @returns api response
 * @description this function used to pause states.
 */
exports.bulkReportPlay = bulkReportPlay;
var bulkReportPause = function bulkReportPause(payload) {
  return {
    type: _reportBulk.actionTypes.BULK_PAUSE,
    payload: payload
  };
};

/**
 * alert on
 * @param payload
 * @returns api response
 * @description this function used to alert on.
 */
exports.bulkReportPause = bulkReportPause;
var bulkReportAlertOn = function bulkReportAlertOn(payload) {
  return {
    type: _reportBulk.actionTypes.BULK_ALERT_ON,
    payload: payload
  };
};

/**
 * alert off
 * @param payload
 * @returns api response
 * @description this function used to alert off.
 */
exports.bulkReportAlertOn = bulkReportAlertOn;
var bulkReportAlertOff = function bulkReportAlertOff(payload) {
  return {
    type: _reportBulk.actionTypes.BULK_ALERT_OFF,
    payload: payload
  };
};

/**
 * restrict
 * @param payload
 * @returns api response
 * @description this function used to restrict states.
 */
exports.bulkReportAlertOff = bulkReportAlertOff;
var bulkReportRestrict = function bulkReportRestrict(payload) {
  return {
    type: _reportBulk.actionTypes.BULK_RESTRICT,
    payload: payload
  };
};

/**
 * unrestrict
 * @param payload
 * @returns api response
 * @description this function used to unrestrict states.
 */
exports.bulkReportRestrict = bulkReportRestrict;
var bulkReportUnrestrict = function bulkReportUnrestrict(payload) {
  return {
    type: _reportBulk.actionTypes.BULK_UNRESTRICT,
    payload: payload
  };
};

/**
 * approve
 * @param payload
 * @returns api response
 * @description this function used to approve.
 */
exports.bulkReportUnrestrict = bulkReportUnrestrict;
var bulkReportApprove = function bulkReportApprove(payload) {
  return {
    type: _reportBulk.actionTypes.BULK_APPROVE,
    payload: payload
  };
};

/**
 * approve
 * @param payload
 * @returns api response
 * @description this function used to approve.
 */
exports.bulkReportApprove = bulkReportApprove;
var bulkReportAddMultiple = function bulkReportAddMultiple(payload) {
  return {
    type: _reportBulk.actionTypes.BULK_ADD,
    payload: payload
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset states.
 */
exports.bulkReportAddMultiple = bulkReportAddMultiple;
var resetReport = function resetReport(payload) {
  return {
    type: _reportBulk.actionTypes.RESET,
    payload: payload
  };
};

/**
 * bulk soft delete
 * @param payload
 * @returns api response
 * @description this function used to bulk soft delete.
 */
exports.resetReport = resetReport;
var bulkReportSoftDelete = function bulkReportSoftDelete(payload) {
  return {
    type: _reportBulk.actionTypes.BULK_SOFT_DELETE,
    payload: payload
  };
};

/**
 * bulk soft delete restore
 * @param payload
 * @returns api response
 * @description this function used to bulk soft delete restore.
 */
exports.bulkReportSoftDelete = bulkReportSoftDelete;
var bulkReportSoftDeleteRestore = function bulkReportSoftDeleteRestore(payload) {
  return {
    type: _reportBulk.actionTypes.BULK_SOFT_DELETE_RESTORE,
    payload: payload
  };
};
exports.bulkReportSoftDeleteRestore = bulkReportSoftDeleteRestore;